import React from 'react'
import {IconRow} from './icon-row'
import {useIntl} from 'react-intl'
import useMultiSite from '../../hooks/use-multi-site'
import {usePaymentIcons} from '../../hooks/useScapiCustomApi'
import {CUSTOMER_TYPE_B2C, CUSTOMER_TYPE_D2B} from '../../constants'
import {useCurrentCustomer} from '../../hooks/use-current-customer'

export const PaymentIcons = (props) => {
    const intl = useIntl()
    const {locale} = useMultiSite()
    const {isD2BCustomer} = useCurrentCustomer().data
    const {data: paymentMethods} = usePaymentIcons(
        {
            parameters: {
                locale: locale.id,
                c_channelType: isD2BCustomer ? CUSTOMER_TYPE_D2B : CUSTOMER_TYPE_B2C
            }
        },
        {}
    )

    if (!paymentMethods?.icons?.length) {
        return null
    }

    return (
        <IconRow
            {...props}
            icons={paymentMethods.icons}
            title={intl.formatMessage({
                id: 'payment-icons.pay_with',
                defaultMessage: 'Pay easily via:'
            })}
        />
    )
}

export default PaymentIcons
